module.exports = __webpack_public_path__ + "img/app_store-icon.0590fc01.png";